module.exports = "/images/phone.png?164f2992155675b86a4dc508d16cc2c7";